import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Clock, Phone } from "lucide-react";
import "./UtilityHeader.css";

function UtilityHeader() {
  return (
    <div className="utility-header">
      <div className="container utility-header__inner">
        <div className="utility-header__left">
          <span className="utility-header__location">
            <MapPin size={12} />
            Detroit, MI
          </span>
          <span className="utility-header__divider" />
          <span className="utility-header__hours">
            <Clock size={12} />
            Mon–Fri 9AM–6PM &nbsp;·&nbsp; Sat 9AM–5PM
          </span>
        </div>
        <div className="utility-header__right">
          <a
            href="tel:+13135828860"
            className="utility-header__link utility-header__phone">
            <Phone size={12} />
            (313) 582-8860
          </a>
          <span className="utility-header__divider" />
          <Link to="/about" className="utility-header__link">
            About
          </Link>
          <span className="utility-header__divider" />
          <Link to="/contact" className="utility-header__link">
            Contact
          </Link>
        </div>
      </div>
    </div>
  );
}

export default UtilityHeader;
